import React, {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from "react";
import { MdClose } from "react-icons/md";
import { intervalToDuration } from "date-fns";
import { toast } from "react-toastify";

import ContainedButton from "components/layout/form/containedButton";
import DatePickerField from "components/layout/form/DatePickerField";
import OutlinedButton from "components/layout/form/outlinedButton";
import api from "services/api";
import theme from "styles/theme";
import { UserInfo } from "pages/MeusDados";

import { Container } from "./styles";
import {
  ContainerButtons,
  Messenger,
  ModalHeader,
  ModalStyle,
  Title,
} from "../styles";

type BirthDateProps = {
  openModal: boolean;
  modalFunction: Dispatch<SetStateAction<boolean>>;
  userInfo: UserInfo;
  setUserInfo: Dispatch<SetStateAction<UserInfo>>;
  setOpenAUCModal: Dispatch<SetStateAction<boolean>>;
};

const BirthDate = ({
  openModal,
  modalFunction,
  userInfo,
  setUserInfo,
  setOpenAUCModal,
}: BirthDateProps): JSX.Element => {
  const [dateUpdate, setDateUpdate] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userInfo && userInfo.birthDate && !dateUpdate) {
      const dateSplit = userInfo.birthDate.split("-");
      setDateUpdate(
        new Date(`${dateSplit[1]}/${dateSplit[2]}/${dateSplit[0]}`)
      );
    }
  }, [userInfo]);

  const BuildFormmatedDate = useCallback((date) => {
    if (date) {
      const day =
        date.getDate().toString().length > 1
          ? date.getDate()
          : `0${date.getDate()}`;
      const month =
        (date.getMonth() + 1).toString().length > 1
          ? date.getMonth() + 1
          : `0${date.getMonth() + 1}`;
      return `${date.getFullYear()}-${month}-${day}`;
    }
    return null;
  }, []);

  const requestPatchCustomers = useCallback(
    async (date) => {
      try {
        setLoading(true);
        const headers = {
          access_token: localStorage.getItem(
            "@UltragazEmpresarial:accessToken"
          ),
        };
        const { unitId } = JSON.parse(
          localStorage.getItem("@UltragazEmpresarial:unitData")
        );
        const body = {
          birthdate: BuildFormmatedDate(date),
          unitId,
        };
        await api.patch(`industrial/customer/v1/customers/me`, body, {
          headers,
        });
        setUserInfo({ ...userInfo, birthDate: body.birthdate });
        setLoading(false);
        modalFunction(false);
      } catch (err) {
        setLoading(false);
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      }
    },
    [api, userInfo, BuildFormmatedDate, setUserInfo, setLoading]
  );

  const handleSubmit = useCallback(
    (date) => {
      const { birthDate } = userInfo;
      const compareDate = BuildFormmatedDate(date);
      if (!loading && birthDate !== compareDate) {
        const { years } = intervalToDuration({
          start: date,
          end: new Date(),
        });
        if (years < 18) {
          setDateUpdate(null);
          setOpenAUCModal(true);
          modalFunction(false);
        } else {
          requestPatchCustomers(date);
        }
      }
    },
    [
      intervalToDuration,
      requestPatchCustomers,
      setDateUpdate,
      loading,
      userInfo,
      BuildFormmatedDate,
    ]
  );

  return (
    <ModalStyle
      show={openModal}
      animation={false}
      centered
      onHide={() => modalFunction(false)}
    >
      <ModalHeader>
        <span>Editar dados</span>
        <MdClose size={24} onClick={() => modalFunction(false)} />
      </ModalHeader>
      <Container>
        <Title>Data de nascimento</Title>
        <DatePickerField
          onChange={(date) => setDateUpdate(date)}
          selected={dateUpdate}
        />
        <Messenger>Não permitido para menores de 18 anos</Messenger>
        <ContainerButtons>
          <OutlinedButton
            color={theme.colors.purple}
            onClick={() => modalFunction(false)}
          >
            Cancelar
          </OutlinedButton>
          <ContainedButton
            onClick={() => handleSubmit(dateUpdate)}
            loading={loading}
          >
            Atualizar
          </ContainedButton>
        </ContainerButtons>
      </Container>
    </ModalStyle>
  );
};

export default BirthDate;
